export default __webpack_public_path__ + "static/media/calculator.4506a210.svg";